import { Command } from '@/app/tracking/api';

interface InteractionResult {
  id: string
  type: string
  progress: number
  status: 'incomplete' | 'completed'
}

export type UpdateInteractionResultTrackingCommandPayload = InteractionResult

export const UpdateInteractionResultTrackingCommandName = 'update-interaction-result' as const;
export type UpdateInteractionResultTrackingCommand =
      Command<typeof UpdateInteractionResultTrackingCommandName, UpdateInteractionResultTrackingCommandPayload>;
